import Button from "react-bootstrap/Button";

const PrimaryButton = ({ children, onClick, ...props }) => {
  const { className } = props;
  if (className) {
    delete props["className"];
  }

  return (
    <Button
      className={`${className} primary-btn`}
      type="button"
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
